export default __webpack_public_path__ + "static/media/AgentLandingPageFinal.4587c7e5.mp4";